export const CATEGORY_QUERY_PARAMETER_ID_WITH_FORMAT =
  /f.category.0=([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})/;
export const TOP_PHRASE_QUERY_PARAMETER = /f.top.phrase=([^&]*)/;
export const CATEGORY_SLUG = /f.category.0=([^&]*)|\/c\/([^&!?]*)*/;

export const PRODUCT_REGEX = /product\/([^&!?]*)*/;
export const CATEGORY_REGEX = /\/c\/(.+)/;
export const VALID_UUID = /^([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12})$/;
export const IS_UUID = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

export const BRAND_PLP_REGEX = /\/b\/(.+)/;
export const CUSTOM_PLP_REGEX = /\/landing\/(.+)/;
export const CUSTOM_HUB_REGEX = /\/hub\/(.+)/;
export const LANDING_PAGE_REGEX = /\/content\/(.+)/;
export const SITE_MAP_FILE_REGEX = /sitemap\/(.+).xml/;
export const BRAND_REGEX = /\/brand\/(.+)/;
export const SEARCH_Q_PARAM = /q=([^&]*)/;
